import Vue            from 'vue';
import axios          from 'axios';
import { baseApiUrl } from '@/global';

const success = res => res;
const error   = err => {
    if (401 === err.response.status) {
        window.location = '/#/';
    } else if (403 === err.response.status) {
        window.location = '/#/403';
    } else if (404 === err.response.status) {
        window.location = '/#/404';
    } else if (500 === err.response.status) {
        window.location = '/#/500';
    } else {
        return Promise.reject(err);
    }
}

axios.interceptors.response.use(success, error);
axios.defaults.baseURL = baseApiUrl;

Vue.use({
    install(Vue) {
        Vue.prototype.$axios = axios;
    }
});
